const buttons = document.querySelectorAll(".document-button");

buttons.forEach(button => {
    button.addEventListener("click", function() {
        this.classList.toggle("active");
        
        // 2. ボタンの親要素（document-item）を取得
        const parentItem = this.closest('.document-item');
        
        // 3. 親要素内にある全てのコンテンツ要素を取得
        const contents = parentItem.querySelectorAll('.document-content');
        
        // 4. 各コンテンツ要素の表示/非表示を切り替え
        contents.forEach(content => {
            content.classList.toggle('active');
        });
    });
});
